<template>
  <div class="main">
    <GoBack :name="`兑换记录`" :type="2" :path="`/mobile/my`"></GoBack>

    <div class="content-box">
      <!-- <div class="herder-box">
        <div
          @click="active = 1"
          :class="['herder herder1', { active: active === 1 }]"
        >
          兑换记录 <span></span>
        </div>
        <div
          @click="active = 2"
          :class="['herder herder2', { active: active === 2 }]"
        >
          我的奖品 <span></span>
        </div>
      </div> -->

      <div
        class="list-box"
        v-if="active === 1"
        @scroll="handleScroll"
        ref="scrollContainer"
      >
        <div
          class="list-item"
          v-for="(item, index) in tableData2"
          :key="(item, index)"
        >
          <div class="left">
            <div class="name1">{{ item.orderId }}</div>
            <div class="name2">{{ item.giftName }}</div>
          </div>
          <div class="right">
            <div class="name1">-{{ item.displayPoints }}金币</div>
            <div class="name2">{{ item.orderDate | dateFrom }}</div>
            <div class="name3" v-if="item.statusDesc === '等待确认'">
              <span style="background-color: #909090"></span>
              {{ item.statusDesc }}
            </div>
            <div class="name3" v-if="item.statusDesc === '等待审核'">
              <span style="background-color: #fa8c16"></span>
              {{ item.statusDesc }}
            </div>
            <div class="name3" v-if="item.statusDesc === '审核通过'">
              <span style="background-color: #ff4d4f"></span>
              {{ item.statusDesc }}
            </div>
            <div class="name3" v-if="item.statusDesc === '审核拒绝'">
              <span style="background-color: #ff4d4f"></span>
              {{ item.statusDesc }}
            </div>
            <div class="name3" v-if="item.statusDesc === '订单取消'">
              <span style="background-color: #bfbfbf"></span>
              {{ item.statusDesc }}
            </div>
            <div class="name3" v-if="item.statusDesc === '订单完成'">
              <span style="background-color: #1890ff"></span>
              {{ item.statusDesc }}
            </div>

            <div class="line-box2" v-if="item.url && item.status === 2">
              <div
                v-if="!item.receiveTime"
                class="unclaimed"
                @click="changeExchangeMethod(item.url, item.giftName)"
              >
                点击领取
              </div>
              <div v-if="item.receiveTime" class="received">已领取</div>
            </div>
          </div>
        </div>
        <div class="flag" v-if="!flag && tableData2.length !== 0">
          触底加载更多
        </div>
        <div class="flag" v-if="flag && tableData2.length !== 0">
          已经到底了~
        </div>
        <van-empty v-if="tableData2.length === 0" description="暂无数据" />
      </div>
      <div v-if="active === 2">
        <van-empty description="暂无数据" />
      </div>
    </div>

    <ExchangeMethod
      v-if="isExchangeMethod"
      @close="isExchangeMethod = false"
      :url="url"
      :name="name"
    ></ExchangeMethod>
  </div>
</template>
<script>
import GoBack from "@/components/goBack.vue";
import { getOrders } from "@/api/mobile";

import ExchangeMethod from "@/components/mobileExchangeMethod";
export default {
  filters: {
    dateFrom(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      active: 1,

      value: null,
      menuTop: 86,
      options: [
        {
          value: 1,
          label: "已完成",
        },
        {
          value: 2,
          label: "未完成",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      options2: [
        {
          value: 1,
          label: "已审核",
        },
        {
          value: 2,
          label: "待审核",
        },
        {
          value: 3,
          label: "其它",
        },
      ],

      flag: false,
      page2: 1,
      size2: 10,
      tableData2: [],

      isExchangeMethod: false,
      url: null,
      name: null,
    };
  },
  methods: {
    changeExchangeMethod(url, name) {
      (this.url = url || "11"), (this.name = name);
      this.isExchangeMethod = true;
    },
    getOrders2(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }
      getOrders({
        page: this.page2,
        size: this.size2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },
    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      // 检查是否接近底部
      console.log(
        container.scrollTop + container.clientHeight,
        container.scrollHeight
      );

      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.getOrders2();
      }
    },

    
  },
  components: {
    GoBack,
    ExchangeMethod,
  },
  created() {
    this.getOrders2();
  },
};
</script>

<style lang="scss" scoped>
.line-box2 {
  padding: 10px 0;
  margin: 0;
  display: flex;
  justify-content: flex-end;
}
.unclaimed {
  width: 82px;
  height: 30px;
  background: #ffa100;
  border-radius: 2px 2px 2px 2px;
  text-align: center;
  line-height: 30px;
  /* margin: 0 auto; */
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
.received {
  width: 82px;
  height: 30px;
  background: #d6d6d6;
  border-radius: 2px 2px 2px 2px;
  text-align: center;
  line-height: 30px;
  /* margin: 0 auto; */
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
}
.flag {
  text-align: center;
  color: #999;
  font-size: 14px;
}
.main {
  min-height: 100vh;
  background-color: #f8f8fa;
  width: 100%;
  .content-box {
    height: calc(100vh - 80px);
    width: 100%;
    position: relative;
    .herder-box {
      display: flex;
      justify-content: space-between;
      height: 30px;
      position: absolute;
      z-index: 100;
      background-color: #f8f8fa;
      width: 100%;
      top: 0;
      .herder {
        color: #232323;
        font-size: 16px;
        line-height: 30px;
        position: relative;
      }
      .herder1 {
        margin-left: 47px;
      }
      .herder2 {
        margin-right: 47px;
      }
      .active {
        color: #8846ff;
        font-weight: bolder;
        span {
          position: absolute;
          display: block;
          width: 14px;
          height: 2px;
          background: #8846ff;
          border-radius: 10px 10px 10px 10px;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .list-box {
      padding: 0 15px;
      padding-top: 10px;
      overflow: auto;
      height: calc(100vh - 80px);
      .list-item {
        width: 100%;
        min-height: 95px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        .left {
          margin-left: 10px;
          color: #232323;
          font-size: 14px;
          .name1 {
            margin-top: 19px;
          }
          .name2 {
            font-weight: bolder;
            margin-top: 9px;
          }
        }
        .right {
          margin-right: 10px;
          text-align: right;
          flex-shrink: 0;
          margin-left: 10px;
          .name1 {
            font-size: 16px;
            font-weight: bolder;
            color: #232323;
            margin-top: 18px;
          }
          .name2 {
            font-size: 12px;
            color: #999999;
            margin-top: 3px;
          }
          .name3 {
            display: flex;
            align-items: center;
            color: #ff6017;
            font-size: 12px;
            margin-top: 5px;
            justify-content: flex-end;
            span {
              width: 4px;
              height: 4px;
              background: #37d807;
              border-radius: 2px;
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}
</style>